import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
// import { connect } from 'react-redux';
// import { withRouter } from 'react-router-dom';
// Libs
// import moment from 'moment';
// import { isNull } from 'lodash';

import SlidingPane from 'react-sliding-pane';
import 'react-sliding-pane/dist/react-sliding-pane.css';
// import { toast } from 'react-toastify';
// import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import DmeDateTimePicker from '../DmeDateTimePicker';
import DropzoneComponent from 'react-dropzone-component';
import { toast } from 'react-toastify';
import LoadingOverlay from 'react-loading-overlay';
import axios from 'axios';
import { API_HOST, HTTP_PROTOCOL } from '../../config';

// Actions
// import { getVehicles } from '../../state/services/vehicleService';

class InsuranceClaimSlider extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            claimant:{},
            sender: {},
            receiver: {},
            claimantRole: null,
            loading: false,
            insuranceClaim: {}
        };

        this.componentConfig = {
            iconFiletypes: ['.pdf', '.jpg', '.jpeg', '.png'],
            showFiletypeIcon: true,
            postUrl: '/upload', // won't be used if autoProcessQueue: false
        };

        this.djsConfig = {
            acceptedFiles: 'image/*,application/pdf',
            addRemoveLinks: true,
            autoProcessQueue: false, // manual submission
        };
    }

    static propTypes = {
        isOpen: PropTypes.bool.isRequired,
        toggleSlider: PropTypes.func.isRequired,
        booking: PropTypes.object,
    };

    componentDidMount() {
        // this.props.getVehicles();
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        if(newProps.isOpen){
            this.fetchInsuranceData();
        }
    }

    fetchInsuranceData = () => {
        console.log(this.props.booking);
        if (!this.props.booking.id) return;
        this.setState({ loading: true });
        const token = localStorage.getItem('token');
        axios.post(`${HTTP_PROTOCOL}://${API_HOST}/fetch-insurance-claim/`,
            {
                bookingId: this.props.booking.id
            },
            {
                headers: {'Authorization': 'JWT ' + token },
            }
        ).then((response) => {
            if (response.status === 200) {                  
                this.setState({insuranceClaim: response.data.insurance_claim, loading: false});
            }
        }).catch((error) => {
            this.setState({ loading: false });
            console.log(error.response);
            toast.error(error.response.data.error.Message);
        });
    }

    handleDropzoneInit = (dropzone) => {
        this.dropzone = dropzone;
    };

    handleInput = (e, type = null) => {
        const { name, value } = e.target;
        if(type === null){
            this.setState({
                [name]: value,
            });
        }else{
            this.setState(prev => ({
                ...prev,
                [type] : {
                    ...prev[type],
                    [name]: value
                }
            }));
        }
    };

    onDateTimeChange(date, src) {
        this.setState({[src]: date});
    }

    handleSubmit = (e) => {
        e.preventDefault();

        if(!this.state.insuranceClaim.insurance_quote_id || !this.state.insuranceClaim.insurance_policy_id){
            toast.error('Insurance service is not applied to this booking.');
            return;
        }

        if(!this.state.goodsDispatchedDateTime){
            toast.warning('Please select Goods Dispatched Date and Time');
            return;
        }
        const formData = new FormData();
        formData.append('bookingId', this.props.booking.id);
        console.log(this.props.booking.id);
        formData.append('goodsDispatchedDateTime', moment(this.state.goodsDispatchedDateTime).format('YYYY-MM-DD'));
        formData.append('initialContactDate', moment(this.state.initialContactDate).format('YYYY-MM-DD'));
        formData.append('descriptionOfGoods', this.state.descriptionOfGoods);
        formData.append('descriptionOfLossOrDamage', this.state.descriptionOfLossOrDamage);
        formData.append('claimType', this.state.claimType);
        formData.append('damagedGoodsLocation', this.state.damagedGoodsLocation);
        formData.append('claimantRole', this.state.claimantRole);
        if(this.state.claimType === '0'){
            formData.append('goodsReceivedDateTime', moment(this.state.goodsReceivedDateTime).format('YYYY-MM-DD'));
            formData.append('isSalvageRequired', this.state.isSalvageRequired);
            formData.append('isGoodsRepairable', this.state.isGoodsRepairable);
        }
        formData.append('sender_longitude', 0);
        formData.append('sender_latitude', 0);
        formData.append('receiver_longitude', 0);
        formData.append('receiver_latitude', 0);
        // formData.append('sender_longitude', this.state.sender.longitude);
        // formData.append('sender_latitude', this.state.sender.latitude);
        // formData.append('receiver_longitude', this.state.receiver.longitude);
        // formData.append('receiver_latitude', this.state.receiver.latitude);
        const files = this.dropzone.getAcceptedFiles();

        files.forEach((file) => {
            formData.append('files', file);
        });

        this.setState({ loading: true });
        const token = localStorage.getItem('token');
        axios.post(`${HTTP_PROTOCOL}://${API_HOST}/insurance-claim/`, formData, {
            headers: {'Authorization': 'JWT ' + token },
        }).then((response) => {
            if (response.status === 200) {                  
                this.setState({ loading: false });
                toast.success('Insurance claim submitted successfully.');
                this.fetchInsuranceData();
            }
        }).catch((error) => {
            this.setState({ loading: false });
            console.log(error.response);
            toast.error(error.response.data.error.Message);
        });
    }

    render() {
        const { toggleSlider, isOpen, booking } = this.props;
        const {claimantRole, insuranceClaim } = this.state;
        const claim_number = insuranceClaim.claim_number;
        const insurance_quote_id = insuranceClaim.insurance_quote_id;
        const insurance_policy_id = insuranceClaim.insurance_policy_id;
        let claimant = {};

        if (claimantRole === '0' || insuranceClaim.claimant_role === 0){ // Sender
            claimant = {
                name: booking.puCompany,
                email: booking.pu_Email,
                address1: booking.pu_Address_Street_1,
                address2: booking.pu_Address_street_2,
                city:booking.pu_Address_Suburb,
                state:booking.pu_Address_State,
                postal_code:booking.pu_Address_PostalCode,
                street:booking.pu_Address_Street_1,
                country:booking.pu_Address_Country,
                // latitude: sender.latitude,
                // longitude: sender.longitude,
                phone:booking.pu_Phone_Main,
                claimantContact:booking.pu_Contact_F_L_Name
            };
        } else if (claimantRole === '1' || insuranceClaim.claimant_role === 1) { // Receiver
            claimant = {
                name: booking.deToCompanyName,
                email: booking.de_Email,
                address1: booking.de_To_Address_Street_1,
                address2: booking.de_To_Address_Street_2,
                city:booking.de_To_Address_Suburb,
                state:booking.de_To_Address_State,
                postal_code:booking.de_To_Address_PostalCode,
                street:booking.de_To_Address_Street_1,
                country:booking.de_To_Address_Country,
                // latitude: receiver.latitude,
                // longitude: receiver.longitude,
                phone:booking.de_to_Phone_Main,
                claimantContact:booking.de_to_Contact_F_LName
            };
        } else if (claimantRole === '2' || insuranceClaim.claimant_role === 2) { // Third Party - DME
            claimant = {
                name: 'Deliver Me',
                email: 'supports@deliver-me.com.au',
                address1: '59-75 Grafton Street',
                address2: '',
                city:'Bondi Junction',
                state:'NSW',
                postal_code:'2022',
                street:'59-75 Grafton Street',
                country:'Australia',
                // latitude: -33.89060418324227,
                // longitude: 151.2462597890988,
                phone:'028311100', // Need to check
                claimantContact:'Deliver Me'
            };
        }

        return (
            <SlidingPane
                className='insurance-claim-slider'
                isOpen={isOpen}
                title='Insurace Claim Slider'
                subtitle=''
                onRequestClose={toggleSlider}
            >
                <LoadingOverlay
                    className='insurance-claim-slider-overlay'
                    active={this.state.loading}
                    spinner
                    text='Loading...'
                >
                    <form className='d-flex flex-column col-count claim-form' onSubmit={this.handleSubmit} method="POST" encType="multipart/form-data">
                        {
                            claim_number && 
                            <div className='d-flex p-3 font-16'>
                                <span className='text-danger'>Claim Number: &nbsp;&nbsp;</span> { insuranceClaim['claim_number'] }
                            </div>
                        }
                        <div className='d-flex'>
                            {
                                insurance_quote_id &&
                                <div className='flex flex-col flex-1 px-3'>
                                    <label className='form-label'>Insurance Quote Id:</label>
                                    <div className="mx-3 flex-grow-1 flex items-center claim-cell">
                                        <span className='px-3'>{insurance_quote_id}</span>
                                    </div>
                                </div>
                            }
                            {
                                insurance_policy_id &&
                                <div className='flex flex-col flex-1 px-3'>
                                    <label className='form-label'>Insurance Policy Id:</label>
                                    <div className="mx-3 flex-grow-1 flex items-center claim-cell">
                                        <span className='px-3'>{insurance_policy_id}</span>
                                    </div>
                                </div>
                            }
                        </div>
                        <div className='d-flex claim-info'>
                            <div className='flex flex-col flex-1 px-3'>
                                <label className='form-label'>Consignment No:</label>
                                <div className="mx-3 flex-grow-1 flex items-center claim-cell">
                                    <span className='px-3'>{booking.v_FPBookingNumber}</span>
                                </div>
                            </div>
                            <div className='flex flex-col flex-1 px-3'>
                                <label className='form-label'>Claim Value:</label>
                                <div className="mx-3 flex-grow-1 flex items-center claim-cell">
                                    <span className='px-3'>{booking.client_sales_total}</span>
                                </div>
                            </div>
                            <div className='flex flex-col flex-1 px-3'>
                                <label className='form-label'>Goods Dispatched Date/Time<span className='required'/>:</label>
                                {
                                    claim_number ? 
                                        <div className="mx-3 flex-grow-1 flex items-center claim-cell">
                                            <span className='px-3'>{insuranceClaim['goods_dispatched_date_time']}</span>
                                        </div>
                                        : <div className='px-3'>
                                            <DmeDateTimePicker
                                                className="form-control"
                                                selected={this.state.goodsDispatchedDateTime || null}
                                                selectPastDates={true}
                                                onChange={(date) => this.onDateTimeChange(date, 'goodsDispatchedDateTime')}
                                            />
                                        </div>
                                }
                                
                            </div>
                            <div className='flex flex-col flex-1 px-3'>
                                <label className='form-label'>Initial Contact Date:</label>
                                {
                                    claim_number ? 
                                        <div className="mx-3 flex-grow-1 flex items-center claim-cell">
                                            <span className='px-3'>{insuranceClaim['initial_contact_date']}</span>
                                        </div>
                                        : <div className='px-3'>
                                            <DmeDateTimePicker
                                                className="form-control"
                                                selected={this.state.initialContactDate || null}
                                                selectPastDates={true}
                                                onChange={(date) => this.onDateTimeChange(date, 'initialContactDate')}
                                            />
                                        </div>
                                }
                            </div>
                        </div>
                        <div className='d-flex'>
                            <div className='flex flex-col flex-1 px-3'>
                                <label className='form-label'>Description Of Goods:</label>
                                {
                                    claim_number ? 
                                        <div className="mx-3 flex-grow-1 flex items-center claim-cell">
                                            <span className='px-3'>{insuranceClaim['description_of_goods']}</span>
                                        </div>
                                        : <div className='px-3'> 
                                            <textarea 
                                                placeholder="Enter description of goods"
                                                name="descriptionOfGoods"
                                                className="form-control"
                                                onChange={(e) => this.handleInput(e)}
                                                value={this.state.descriptionOfGoods || ''}
                                            />
                                        </div>
                                }
                            </div>
                            <div className='flex flex-col flex-1 px-3'>
                                <label className='form-label'>Description Of Loss Or Damage:</label>
                                {
                                    claim_number ? 
                                        <div className="mx-3 flex-grow-1 flex items-center claim-cell">
                                            <span className='px-3'>{insuranceClaim['description_of_loss_or_damage']}</span>
                                        </div>
                                        :<div className='px-3'>
                                            <textarea 
                                                placeholder="Enter description of loss or damage"
                                                name="descriptionOfLossOrDamage"
                                                className="form-control"
                                                value={this.state.descriptionOfLossOrDamage || ''}
                                                onChange={(e) => this.handleInput(e)}
                                            />
                                        </div>
                                }
                            </div>  
                        </div>
                        <div className='flex'>
                            <div className='flex flex-col flex-1 px-3'>
                                <label className='form-label'>Claim Type<span className='required'/>:</label>
                                {
                                    claim_number ? 
                                        <div className="mx-3 flex-grow-1 flex items-center claim-cell">
                                            <span className='px-3'>{(insuranceClaim['claim_type'] == 0 ? 'Damage' : 'Loss')}</span>
                                        </div>
                                        : <div className='px-3'>
                                            <select
                                                className='form-control'
                                                name="claimType"
                                                value={this.state.claimType || ''}
                                                onChange={(e) => this.handleInput(e)}
                                                required
                                            >
                                                <option value="" defaultValue="" disabled hidden>Select category</option>
                                                <option value="0">Damage</option>
                                                <option value="1">Loss</option>
                                            </select>
                                        </div>
                                }
                            </div>
                            <div className='flex flex-col flex-1 px-3'>
                                <label className='form-label'>Damaged Goods Location<span className='required'/>:</label>
                                {
                                    claim_number ? 
                                        <div className="mx-3 flex-grow-1 flex items-center claim-cell">
                                            <span className='px-3'>{insuranceClaim['damaged_goods_location']}</span>
                                        </div>
                                        : <div className='px-3'>
                                            <input 
                                                placeholder="Enter damaged location"
                                                name="damagedGoodsLocation"
                                                type="text"
                                                className="form-control"
                                                value={this.state.damagedGoodsLocation || ''}
                                                onChange={(e) => this.handleInput(e)}
                                                required
                                            />
                                        </div>
                                }
                            </div>
                            <div className='flex flex-col flex-1 px-3'>
                                <label className='form-label'>Claimant Role<span className='required'/>:</label>
                                {
                                    claim_number ? 
                                        <div className="mx-3 flex-grow-1 flex items-center claim-cell">
                                            <span className='px-3'>
                                                {Number(insuranceClaim['claimant_role']) === 0 && 'Sender'}
                                                {Number(insuranceClaim['claimant_role']) === 1 && 'Receiver'}
                                                {Number(insuranceClaim['claimant_role']) === 2 && 'Third party - DME'}
                                            </span>
                                        </div>
                                        : <div className='px-3'>
                                            <select
                                                className='form-control'
                                                name="claimantRole"
                                                value={this.state.claimantRole || ''}
                                                onChange={(e) => this.handleInput(e)}
                                                required
                                            >
                                                <option value="" defaultValue="" disabled hidden>Select category</option>
                                                <option value="0">Sender</option>
                                                <option value="1">Receiver</option>
                                                <option value="2">Third party - DME</option>
                                                {/* <option value="3">No information</option> */}
                                            </select>
                                        </div>
                                }
                            </div>
                        </div>
                        {
                            this.state.claimType === '0' &&
                            <div className='flex'>
                                <div className='flex flex-col flex-1 px-3'>
                                    <label className='form-label'>Goods Received Date/Time<span className='required'/>:</label>
                                    {
                                        claim_number ? 
                                            <div className="mx-3 flex-grow-1 flex items-center claim-cell">
                                                <span className='px-3'>
                                                    {insuranceClaim['goods_received_date_time']}
                                                </span>
                                            </div>
                                            : 
                                            <div className='px-3'>
                                                <DmeDateTimePicker
                                                    className="form-control"
                                                    selected={this.state.goodsReceivedDateTime || null}
                                                    selectPastDates={true}
                                                    onChange={(date) => this.onDateTimeChange(date, 'goodsReceivedDateTime')}
                                                />
                                            </div>
                                    }
                                </div>
                                <div className='flex flex-col flex-1 px-3'>
                                    <label className='form-label'>Is Salvage Required<span className='required'/>:</label>
                                    {
                                        claim_number ? 
                                            <div className="mx-3 flex-grow-1 flex items-center claim-cell">
                                                <span className='px-3'>
                                                    {Number(insuranceClaim['is_salvage_required']) === 0 && 'No'}
                                                    {Number(insuranceClaim['is_salvage_required']) === 1 && 'Yes'}
                                                </span>
                                            </div>
                                            : 
                                            <div className='px-3'>
                                                <select
                                                    className='form-control'
                                                    name="isSalvageRequired"
                                                    value={this.state.isSalvageRequired || ''}
                                                    onChange={(e) => this.handleInput(e)}
                                                    required
                                                >
                                                    <option value="" defaultValue="" disabled hidden>Select Salvage required</option>
                                                    <option value="0">No</option>
                                                    <option value="1">Yes</option>
                                                </select>
                                            </div>
                                    }
                                </div>
                                <div className='flex flex-col flex-1 px-3'>
                                    <label className='form-label'>Is Goods Repairable<span className='required'/>:</label>
                                    {
                                        claim_number ? 
                                            <div className="mx-3 flex-grow-1 flex items-center claim-cell">
                                                <span className='px-3'>
                                                    {Number(insuranceClaim['is_goods_repairable']) === 0 && 'No'}
                                                    {Number(insuranceClaim['is_goods_repairable']) === 1 && 'Yes'}
                                                </span>
                                            </div>
                                            : 
                                            <div className='px-3'>
                                                <select
                                                    className='form-control'
                                                    name="isGoodsRepairable"
                                                    value={this.state.isGoodsRepairable || ''}
                                                    onChange={(e) => this.handleInput(e)}
                                                    required
                                                >
                                                    <option value="" defaultValue="" disabled hidden>Select category</option>
                                                    <option value="0">No</option>
                                                    <option value="1">Yes</option>
                                                </select>
                                            </div>
                                    }
                                </div>
                            </div>
                        }
                        <hr/>
                        <div className='flex'>
                            <div className='flex flex-col claimant flex-1 p-3 justify-content-start'>
                                <h4>Claimant</h4>
                                {/* <div className='flex flex-row justify-content-between'>
                                    <label className='form-label'>Account Number:</label>
                                    <div className='px-3 flex-grow-1 flex items-center'>
                                        <input 
                                            placeholder="Enter account number"
                                            name="accountNumber"
                                            type="text"
                                            className="form-control"
                                            value={this.state.claimant.accountNumber || ''}
                                            onChange={(e) => this.handleInput(e, 'claimant')}
                                        />
                                    </div>
                                </div> */}
                                <div className='flex flex-row justify-content-between'>
                                    <label className='form-label'>Name:</label>
                                    <div className='px-3 flex-grow-1 flex items-center claim-cell'>
                                        <span>{claimant.name}</span>
                                    </div>
                                </div>
                                <div className='flex flex-row justify-content-between'>
                                    <label className='form-label'>Email:</label>
                                    <div className='px-3 flex-grow-1 flex items-center claim-cell'>
                                        <span>{claimant.email}</span>
                                    </div>
                                </div>
                                {/* <div className='flex flex-row justify-content-between'>
                                    <label className='form-label'>Address:</label>
                                    <div className='px-3 flex-grow-1 flex items-center'>
                                        {claimant.adress1}
                                    </div>
                                </div> */}
                                <div className='flex flex-row justify-content-between'>
                                    <label className='form-label'>Address Line 1:</label>
                                    <div className='px-3 flex-grow-1 flex items-center claim-cell'>
                                        <span>{claimant.address1}</span>
                                    </div>
                                </div>
                                <div className='flex flex-row justify-content-between'>
                                    <label className='form-label'>Address Line 2:</label>
                                    <div className='px-3 flex-grow-1 flex items-center claim-cell'>
                                        <span>{claimant.address2}</span>
                                    </div>
                                </div>
                                <div className='flex flex-row justify-content-between'>
                                    <label className='form-label'>City:</label>
                                    <div className='px-3 flex-grow-1 flex items-center claim-cell'>
                                        <span>{claimant.city}</span>
                                    </div>
                                </div>
                                <div className='flex flex-row justify-content-between'>
                                    <label className='form-label'>State:</label>
                                    <div className='px-3 flex-grow-1 flex items-center claim-cell'>
                                        <span>{claimant.state}</span>
                                    </div>
                                </div>
                                <div className='flex flex-row justify-content-between'>
                                    <label className='form-label'>Postal Code:</label>
                                    <div className='px-3 flex-grow-1 flex items-center claim-cell'>
                                        <span>{claimant.postal_code}</span>
                                    </div>
                                </div>
                                <div className='flex flex-row justify-content-between'>
                                    <label className='form-label'>Street:</label>
                                    <div className='px-3 flex-grow-1 flex items-center claim-cell'>
                                        <span>{claimant.address1}</span>
                                    </div>
                                </div>
                                <div className='flex flex-row justify-content-between'>
                                    <label className='form-label'>Country:</label>
                                    <div className='px-3 flex-grow-1 flex items-center claim-cell'>
                                        <span>{claimant.country}</span>
                                    </div>
                                </div>
                                {/* <div className='flex flex-row justify-content-between'>
                                    <label className='form-label'>Latitude:</label>
                                    <div className='px-3 flex-grow-1 flex items-center claim-cell'>
                                        <span>{claimant.latitude}</span>
                                    </div>
                                </div>
                                <div className='flex flex-row justify-content-between'>
                                    <label className='form-label'>Longitude:</label>
                                    <div className='px-3 flex-grow-1 flex items-center claim-cell'>
                                        <span>{claimant.longitude}</span>
                                    </div>
                                </div> */}
                                <div className='flex flex-row justify-content-between'>
                                    <label className='form-label'>Phone:</label>
                                    <div className='px-3 flex-grow-1 flex items-center claim-cell'>
                                        <span>{claimant.phone}</span>
                                    </div>
                                </div>
                                <div className='flex flex-row justify-content-between'>
                                    <label className='form-label'>Claimant Contact:</label>
                                    <div className='px-3 flex-grow-1 flex items-center claim-cell'>
                                        <span>{claimant.claimantContact}</span>
                                    </div>
                                </div>
                            </div>
                            <div className='flex flex-col sender flex-1 p-3 justify-content-start'>
                                <h4>Sender</h4>
                                {/* <div className='flex flex-row justify-content-between'>
                                    <label className='form-label'>accountNumber:</label>
                                    <div className='px-3 flex-grow-1 flex items-center'>
                                        <input 
                                            placeholder="Enter account number"
                                            name="accountNumber"
                                            type="text"
                                            className="form-control"
                                            value={this.state.sender.accountNumber || ''}
                                            onChange={(e) => this.handleInput(e, 'sender')}
                                        />
                                    </div>
                                </div> */}
                                <div className='flex flex-row justify-content-between'>
                                    <label className='form-label'>Name:</label>
                                    <div className='px-3 flex-grow-1 flex items-center claim-cell'>
                                        <span>{booking.puCompany}</span>
                                    </div>
                                </div>
                                <div className='flex flex-row justify-content-between'>
                                    <label className='form-label'>Email:</label>
                                    <div className='px-3 flex-grow-1 flex items-center claim-cell'>
                                        <span>{booking.pu_Email}</span>
                                    </div>
                                </div>
                                {/* <div className='flex flex-row justify-content-between'>
                                    <label className='form-label'>Address:</label>
                                    <div className='px-3 flex-grow-1 flex items-center claim-cell'>
                                        <input 
                                            placeholder="Enter address"
                                            name="address"
                                            type="text"
                                            className="form-control"
                                            value={this.state.sender.address || ''}
                                            onChange={(e) => this.handleInput(e, 'sender')}
                                            required
                                        />
                                    </div>
                                </div> */}
                                <div className='flex flex-row justify-content-between'>
                                    <label className='form-label'>Address Line 1:</label>
                                    <div className='px-3 flex-grow-1 flex items-center claim-cell'>
                                        <span>{booking.pu_Address_Street_1}</span>
                                    </div>
                                </div>
                                <div className='flex flex-row justify-content-between'>
                                    <label className='form-label'>Address Line 2 :</label>
                                    <div className='px-3 flex-grow-1 flex items-center claim-cell'>
                                        <span>{booking.pu_Address_street_2}</span>
                                    </div>
                                </div>
                                <div className='flex flex-row justify-content-between'>
                                    <label className='form-label'>City:</label>
                                    <div className='px-3 flex-grow-1 flex items-center claim-cell'>
                                        <span>{booking.pu_Address_Suburb}</span>
                                    </div>
                                </div>
                                <div className='flex flex-row justify-content-between'>
                                    <label className='form-label'>State:</label>
                                    <div className='px-3 flex-grow-1 flex items-center claim-cell'>
                                        <span>{booking.pu_Address_State}</span>
                                    </div>
                                </div>
                                <div className='flex flex-row justify-content-between'>
                                    <label className='form-label'>Postal Code:</label>
                                    <div className='px-3 flex-grow-1 flex items-center claim-cell'>
                                        <span>{booking.pu_Address_PostalCode}</span>
                                    </div>
                                </div>
                                <div className='flex flex-row justify-content-between'>
                                    <label className='form-label'>Street:</label>
                                    <div className='px-3 flex-grow-1 flex items-center claim-cell'>
                                        <span>{booking.pu_Address_Street_1}</span>
                                    </div>
                                </div>
                                <div className='flex flex-row justify-content-between'>
                                    <label className='form-label'>Country:</label>
                                    <div className='px-3 flex-grow-1 flex items-center claim-cell'>
                                        <span>{booking.pu_Address_Country}</span>
                                    </div>
                                </div>
                                {/* <div className='flex flex-row justify-content-between'>
                                    <label className='form-label'>Latitude<span className='required'/>:</label>
                                    {
                                        claim_number ? 
                                            <div className="mx-3 flex-grow-1 flex items-center claim-cell">
                                                <span className='px-3'>
                                                    {insuranceClaim['sender_latitude']}
                                                </span>
                                            </div>
                                            :
                                            <div className='px-3 flex-grow-1 flex items-center b-none m-0'>
                                                <input 
                                                    placeholder="Enter latitude"
                                                    name="latitude"
                                                    type="number"
                                                    className="form-control"
                                                    value={this.state.sender.latitude || ''}
                                                    onChange={(e) => this.handleInput(e, 'sender')}
                                                    required
                                                />
                                            </div>
                                    }
                                </div>
                                <div className='flex flex-row justify-content-between'>
                                    <label className='form-label'>Longitude<span className='required'/>:</label>
                                    {
                                        claim_number ? 
                                            <div className="mx-3 flex-grow-1 flex items-center claim-cell">
                                                <span className='px-3'>
                                                    {insuranceClaim['sender_longitude']}
                                                </span>
                                            </div>
                                            :
                                            <div className='px-3 flex-grow-1 flex items-center b-none m-0'>
                                                <input 
                                                    placeholder="Enter longitude"
                                                    name="longitude"
                                                    type="number"
                                                    className="form-control"
                                                    value={this.state.sender.longitude || ''}
                                                    onChange={(e) => this.handleInput(e, 'sender')}
                                                    required
                                                />
                                            </div>
                                    }
                                </div> */}
                                <div className='flex flex-row justify-content-between'>
                                    <label className='form-label'>Claimant Party Type:</label>
                                    <div className='px-3 flex-grow-1 flex items-center claim-cell'>
                                        <span>{booking.pu_Address_Type || 'Business'}</span>
                                        {/* <select 
                                            placeholder="Enter Sender Contact"
                                            name="senderContact"
                                            type="number"
                                            className="form-control"
                                            value={this.state.sender.senderContact || ''}
                                            onChange={(e) => this.handleInput(e, 'sender')}
                                            required
                                        >
                                            <option value="" disabled hidden></option>
                                            <option value="0">Individual</option>
                                            <option value="1">Business</option>
                                            <option value="2">Manufacturer</option>
                                            <option value="3">Wholesaler</option>
                                            <option value="4">Retailer</option>
                                        </select> */}
                                    </div>
                                </div>
                            </div>
                            <div className='flex flex-col receiver flex-1 p-3 justify-content-start'>
                                <h4>Receiver</h4>
                                {/* <div className='flex flex-row justify-content-between'>
                                    <label className='form-label'>accountNumber:</label>
                                    <div className='px-3 flex-grow-1 flex items-center claim-cell'>
                                        <input 
                                            placeholder="Enter account number"
                                            name="accountNumber"
                                            type="text"
                                            className="form-control"
                                            value={this.state.receiver.accountNumber || ''}
                                            onChange={(e) => this.handleInput(e, 'receiver')}
                                        />
                                    </div>
                                </div> */}
                                <div className='flex flex-row justify-content-between'>
                                    <label className='form-label'>Name:</label>
                                    <div className='px-3 flex-grow-1 flex items-center claim-cell'>
                                        <span>{booking.deToCompanyName}</span>
                                    </div>
                                </div>
                                <div className='flex flex-row justify-content-between'>
                                    <label className='form-label'>Email:</label>
                                    <div className='px-3 flex-grow-1 flex items-center claim-cell'>
                                        <span>{booking.de_Email}</span>
                                    </div>
                                </div>
                                {/* <div className='flex flex-row justify-content-between'>
                                    <label className='form-label'>Address:</label>
                                    <div className='px-3 flex-grow-1 flex items-center claim-cell'>
                                        {'Full Address'}
                                    </div>
                                </div> */}
                                <div className='flex flex-row justify-content-between'>
                                    <label className='form-label'>Address Line 1:</label>
                                    <div className='px-3 flex-grow-1 flex items-center claim-cell'>
                                        <span>{booking.de_To_Address_Street_1}</span>
                                    </div>
                                </div>
                                <div className='flex flex-row justify-content-between'>
                                    <label className='form-label'>Address Line 2 :</label>
                                    <div className='px-3 flex-grow-1 flex items-center claim-cell'>
                                        <span>{booking.de_To_Address_Street_2}</span>
                                    </div>
                                </div>
                                <div className='flex flex-row justify-content-between'>
                                    <label className='form-label'>City:</label>
                                    <div className='px-3 flex-grow-1 flex items-center claim-cell'>
                                        <span>{booking.de_To_Address_Suburb}</span>
                                    </div>
                                </div>
                                <div className='flex flex-row justify-content-between'>
                                    <label className='form-label'>State:</label>
                                    <div className='px-3 flex-grow-1 flex items-center claim-cell'>
                                        <span>{booking.de_To_Address_State}</span>
                                    </div>
                                </div>
                                <div className='flex flex-row justify-content-between'>
                                    <label className='form-label'>Postal Code:</label>
                                    <div className='px-3 flex-grow-1 flex items-center claim-cell'>
                                        <span>{booking.de_To_Address_PostalCode}</span>
                                    </div>
                                </div>
                                <div className='flex flex-row justify-content-between'>
                                    <label className='form-label'>Street:</label>
                                    <div className='px-3 flex-grow-1 flex items-center claim-cell'>
                                        <span>{booking.de_To_Address_Street_1}</span>
                                    </div>
                                </div>
                                <div className='flex flex-row justify-content-between'>
                                    <label className='form-label'>Country:</label>
                                    <div className='px-3 flex-grow-1 flex items-center claim-cell'>
                                        <span>{booking.de_To_Address_Country}</span>
                                    </div>
                                </div>
                                {/* <div className='flex flex-row justify-content-between'>
                                    <label className='form-label'>Latitude<span className='required'/>:</label>
                                    {
                                        claim_number ? 
                                            <div className="mx-3 flex-grow-1 flex items-center claim-cell">
                                                <span className='px-3'>
                                                    {insuranceClaim['receiver_latitude']}
                                                </span>
                                            </div>
                                            :
                                            <div className='px-3 flex-grow-1 flex items-center claim-cell b-none m-0'>
                                                <input 
                                                    placeholder="Enter latitude"
                                                    name="latitude"
                                                    type="number"
                                                    className="form-control"
                                                    value={this.state.receiver.latitude || ''}
                                                    onChange={(e) => this.handleInput(e, 'receiver')}
                                                    required
                                                />
                                            </div>
                                    }
                                </div>
                                <div className='flex flex-row justify-content-between'>
                                    <label className='form-label'>Longitude<span className='required'/>:</label>
                                    {
                                        claim_number ? 
                                            <div className="mx-3 flex-grow-1 flex items-center claim-cell">
                                                <span className='px-3'>
                                                    {insuranceClaim['receiver_longitude']}
                                                </span>
                                            </div>
                                            :
                                            <div className='px-3 flex-grow-1 flex items-center claim-cell b-none m-0'>
                                                <input 
                                                    placeholder="Enter longitude"
                                                    name="longitude"
                                                    type="number"
                                                    className="form-control"
                                                    value={this.state.receiver.longitude || ''}
                                                    onChange={(e) => this.handleInput(e, 'receiver')}
                                                    required
                                                />
                                            </div>
                                    }
                                </div> */}
                                <div className='flex flex-row justify-content-between'>
                                    <label className='form-label'>Claimant Party Type:</label>
                                    <div className='px-3 flex-grow-1 flex items-center claim-cell'>
                                        <span>{booking.de_To_AddressType || 'Business'}</span>
                                        {/* <select 
                                            placeholder="Enter Receiver Contact"
                                            name="contact"
                                            type="number"
                                            className="form-control"
                                            value={this.state.receiver.contact || ''}
                                            onChange={(e) => this.handleInput(e, 'receiver')}
                                            required
                                        >
                                            <option value="" disabled hidden></option>
                                            <option value="0">Individual</option>
                                            <option value="1">Business</option>
                                            <option value="2">Manufacturer</option>
                                            <option value="3">Wholesaler</option>
                                            <option value="4">Retailer</option>
                                        </select> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {
                            !claim_number && (
                                <React.Fragment>
                                    <DropzoneComponent
                                        config={this.componentConfig}
                                        djsConfig={this.djsConfig}
                                        eventHandlers={{
                                            init: this.handleDropzoneInit,
                                        }}
                                    />
                                    <button className='btn btn-primary' type='submit'>Claim</button>
                                </React.Fragment>
                            )
                        }
                    </form>
                </LoadingOverlay>
            </SlidingPane>
        );
    }
}

// const mapStateToProps = (state) => {
//     return {
//         vehicles: state.vehicle.vehicles,
//     };
// };

// const mapDispatchToProps = (dispatch) => {
//     return {
//         getVehicles: () => dispatch(getVehicles()),
//     };
// };

// export default withRouter(connect(mapStateToProps, mapDispatchToProps)(InsuranceClaimSlider));
export default InsuranceClaimSlider;


// WEBPACK FOOTER //
// ./src/components/Sliders/InsuranceClaimSlider.js